import { BaseDto } from '@/shared/dtos/base-dto';
import { enumeracion } from './enumeracion';
import { tipo_enumeracionesDto } from './tipo_enumeracionesDto';

export class Cabecera_Enumeraciones_FormularioDto extends BaseDto {
    public cabezera !: tipo_enumeracionesDto;
    public enumeraciones !: enumeracion[];
 } 
